module.exports = "<div :class=\"{'weui_navbar_item': true, 'weui_bar_item_on': isSelected}\"  @click=\"selectItem\">\n  <slot></slot>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tab/navbar-item.vue
 ** module id = 139
 ** module chunks = 0
 **/